<template>
  <span v-if="status" class="efficiency-test-status">
    <span :class="['status-bullet', statusClass]"></span>
    <span>{{ statusText }}</span>
  </span>
</template>

<script>
// Status of an efficiency test (Created / InProgress / WaitingResources / Ready / Failed), shared by the efficiency
// tests list (EfficiencyTestsList.vue) and the product details tab (EfficiencyTestsTable.vue):
// the bullet always stays on the left of the label, on a single line.
export default {
  props: {
    status: {
      type: String,
      default: null,
    },
  },
  computed: {
    statusClass() {
      return 'status-bullet-' + this.status.toLowerCase()
    },
    statusText() {
      return this.$t('efficiencyTestsList.efficiencyTestsListTable.statusOptions.' + this.status)
    },
  },
}
</script>

<style lang="scss" scoped>
@keyframes okvPulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.45;
    transform: scale(0.82);
  }
}
.efficiency-test-status {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.status-bullet {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: 0 0 auto;
  margin-right: 0.375rem;
}
.status-bullet-created {
  background: rgb(255, 255, 255);
  border: 1px solid rgb(173, 181, 189);
}
.status-bullet-ready {
  background: rgb(40, 167, 69);
}
.status-bullet-inprogress {
  background: rgb(255, 193, 7);
  animation: 1.4s ease-in-out 0s infinite normal none running okvPulse;
}
.status-bullet-waitingresources {
  background: rgb(23, 162, 184);
  animation: 1.4s ease-in-out 0s infinite normal none running okvPulse;
}
.status-bullet-failed {
  background: rgb(192, 67, 42);
}
</style>
